import { Box, Button, Divider, Grid2, Stack, Typography } from "@mui/material";
import { HashLink } from "react-router-hash-link";
import { LegalDocumentViewerProps } from "./types";
import "./styles.scss";
import { DocumentSection } from "./document-section";
import { Fragment } from "react/jsx-runtime";
import { PropsWithChildren } from "react";
import { Pages } from "../../utils";

export const LegalDocumentViewer = ({
  documentContent,
  children,
}: PropsWithChildren<LegalDocumentViewerProps>) => {
  const navIds = Object.keys(documentContent).map((key) => `#${key}`);
  const content = Object.values(documentContent);
  const navItems = [
    {
      to: Pages.TERMS_OF_SERVICE,
      text: "Terms of Service",
    },
    {
      to: Pages.PRIVACY_POLICY,
      text: "Privacy Policy",
    },
  ];

  return (
    <Box>
      <Grid2 container>
        <Grid2
          className="document-nav"
          size={{
            xs: 12,
            md: 4,
            lg: 3,
            xl: 2,
          }}
        >
          <Box>
            {navItems.map((item) => (
              <Fragment key={item.to}>
                <Button
                  variant="text"
                  component={HashLink}
                  to={item.to}
                  color={"white" as any}
                  sx={{
                    width: "100%",
                    display: "block",
                  }}
                >
                  <Typography
                    variant="body1"
                    className="text-white"
                    sx={{
                      display: "block",
                    }}
                    component="span"
                  >
                    {item.text}
                  </Typography>
                </Button>
                <Divider />
              </Fragment>
            ))}
          </Box>
        </Grid2>
        <Grid2
          className="document-content"
          size={{
            xs: 12,
            md: 8,
            lg: 9,
            xl: 10,
          }}
          px={2}
          pt={4}
          pb={40}
        >
          <Stack spacing={5}>
            {content.map((section, index) => (
              <DocumentSection
                key={index}
                id={navIds[index]}
                {...section}
                index={index}
              />
            ))}
            {children}
          </Stack>
        </Grid2>
      </Grid2>
    </Box>
  );
};
